import { Subject } from "./Subject.js";
class BehaviorSubject extends Subject {
  // BehaviorSubject always has a current value
  constructor(initialValue) {
    super();
    this._value = initialValue;
  }
  next(data) {
    this._value = data;
    super.next(data);
  }
  _subscribeToSubject(subscriber) {
    const subscription = super._subscribeToSubject(subscriber);
    if (!this._isStopped) {
      subscriber.next(this._value);
    } else if (this._hasError) {
      subscriber.error(this._error);
    } else {
      subscriber.complete();
    }
    return subscription;
  }
  getValue() {
    if (this._hasError) {
      throw this._error;
    }
    return this._value;
  }
}
export {
  BehaviorSubject
};
//# sourceMappingURL=BehaviorSubject.js.map
